/* eslint-disable @typescript-eslint/dot-notation */
import { Component, ChangeDetectorRef, HostListener, OnDestroy, OnInit, ViewChild, AfterViewInit } from '@angular/core';
import { Router } from '@angular/router';
import { AccountPaymentService, ActionsAnalyticsService, CART_TYPES, CustomizableMobilePlan, FirebaseAdsService, IBasePlan, IFirebaseAddress, MobileCustomPlansServiceNoSync, PURCHASE_INTENT } from '@ztarmobile/zwp-service-backend';
import { debounceTime, distinctUntilChanged, switchMap, takeWhile } from 'rxjs/operators';
import { ALLOW_ATT_ACTIVATION, CUSTOMER_CARE_NUMBER, WEBSITE_URL } from 'src/environments/environment';
import { MetaService } from 'src/services/meta-service.service';
import { ACTIVATION_ROUTE_URLS, PLANS_SHOP_ROUTE_URLS, SHOP_ROUTE_URLS, SUPPORT_ROUTE_URLS } from '../app.routes.names';
import { AppState } from '../app.service';
import { Observable, of, Subscription } from 'rxjs';
import { AddressesAutocompleteService, EquipmentService, IAutoCompletePrediction } from '@ztarmobile/zwp-service-backend-v2';
import { FormControl, NgForm, Validators } from '@angular/forms';
import { ToastrHelperService } from 'src/services/toast-helper.service';
import Swiper, { Keyboard, Navigation, Pagination, SwiperOptions } from 'swiper';
import { SimpleAuthService } from '@ztarmobile/zwp-services-auth';
import { AngularFireAuth } from '@angular/fire/compat/auth';
import { ModalHelper } from 'src/services/modal-helper.service';
import { CAPTCHA_BOT_ERROR_CODE, PARAM_ERROR_MESSAGES, RED, TMO } from '../app.config';
import { AddressAutoCompleteHelperService } from '@services/address-auto-complete.service';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})

export class HomeComponent implements OnInit, OnDestroy, AfterViewInit {
  @ViewChild('compatibilityForm') compatibilityForm: NgForm;

  public jsonLDString: any;
  public innerWidth: any;
  public featuredPlans: IBasePlan[];
  public defaultPlan: IBasePlan;
  public index = 0;
  public processingRequest = false;
  public recaptchaResponse: any;
  public invalidAddress = false;
  public displayedAddressModel: any;
  public address: any;
  public setFoucs = false;
  public displayValidation = false;
  public networkType: string;
  public filteredOptions: Observable<Array<IAutoCompletePrediction>>;
  public filteredOptionsSubscription: Subscription;
  public swiper: any;
  public config: SwiperOptions = {
    direction: 'horizontal',
    keyboard: false,
    mousewheel: false,
    scrollbar: false,
    centeredSlides: true,
    roundLengths: false,
    loopFillGroupWithBlank: false,
    slideToClickedSlide: true,
    slidesOffsetBefore: 0,
    slidesOffsetAfter: 0,
    initialSlide: 1,
    slidesPerView: 'auto',
    centeredSlidesBounds: true,
    observer: true,
    effect: 'slide',
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev'
    },
    pagination: {
      el: '.slider-pagination',
      renderBullet: (index, className) => `<li style="z-index: 10" class="slick-active ${className}"><button ></button></li>`,
      clickable: true
    },
    spaceBetween: 0
  };
  public userCart: CustomizableMobilePlan;
  public userHasDevice = false;
  public activeSlideIndex = 1;
  public recaptchaResolvedSubscription: Subscription;
  public addressControl = new FormControl('', [Validators.required, this.addressAutoCompleteService.addressObjectValidator]);
  public ALLOW_ATT_ACTIVATION = ALLOW_ATT_ACTIVATION;
  
  private streetSearchText: string;
  private tracked: boolean;
  private alive = true;

  constructor(
    private appState: AppState,
    private firebaseAdsService: FirebaseAdsService,
    public router: Router,
    public toastHelper: ToastrHelperService,
    private metaService: MetaService,
    private placesAutoCompleteService: AddressesAutocompleteService,
    private equipmentService: EquipmentService,
    private cdr: ChangeDetectorRef,
    private simpleAuthService: SimpleAuthService,
    private angularFireService: AngularFireAuth,
    private mobilePlansService: MobileCustomPlansServiceNoSync,
    private modalHelper: ModalHelper,
    private analyticsService: ActionsAnalyticsService,
    private addressAutoCompleteService: AddressAutoCompleteHelperService
  ) {
  }

  ngOnInit(): void {
    this.innerWidth = window.innerWidth;
    this.metaService.createCanonicalUrl(WEBSITE_URL);
    this.mobilePlansService.currentPlan.pipe(takeWhile(() => this.alive)).subscribe((cart) => {
      this.userCart = cart;
      this.userHasDevice = !!this.userCart.planDevice && !!this.userCart.planDevice.skuIdentifier && !!this.userCart.planDevice.skuNumber;
    });
    this.prepareSchemaData();
    this.firebaseAdsService.featuredPlans.pipe(takeWhile(() => this.alive)).subscribe((plans) => {
      this.featuredPlans = plans;
      this.featuredPlans.sort((a, b) => a.data - b.data); // sort plans based on data
    });

    const sessionId = sessionStorage.getItem('placesSessionToken');
    this.filteredOptions = this.addressControl.valueChanges.pipe(
      debounceTime(300),
      distinctUntilChanged(),
      switchMap(value => {
        if (typeof value !== 'string' || value.trim().length === 0) {
          return of([]); // Clear the autocomplete suggestions
        }
        return this.placesAutoCompleteService.findAddress(value, sessionId);
      })
    );
  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      this.cdr.detectChanges();
      this.createSwiper();
    }, 200);
  }

  ngOnDestroy(): void {
    this.alive = false;
    if (this.recaptchaResolvedSubscription) {
      this.recaptchaResolvedSubscription.unsubscribe();
    }
  }

  public goToTerms() {
    this.router.navigateByUrl(`${SUPPORT_ROUTE_URLS.BASE}/${SUPPORT_ROUTE_URLS.TERMS_AND_CONDITIONS}`);
  }

  public goToPlans(): void {
    this.router.navigate([`${SHOP_ROUTE_URLS.BASE}/${SHOP_ROUTE_URLS.PLANS_AND_FEATURES}/${PLANS_SHOP_ROUTE_URLS.NEW_PLAN}`]);
  }

  public goToPlanDetails(id): void {
    const params = {};
    params['id'] = id;
    this.router.navigate([`${SHOP_ROUTE_URLS.BASE}${PLANS_SHOP_ROUTE_URLS.BASE}/${PLANS_SHOP_ROUTE_URLS.DETAILS}`, params['id']]);
  }

    public displayFn(option: IAutoCompletePrediction): string {
    return option?.description || '';
  }

  public addressSelected(selectedAddress: IAutoCompletePrediction): void {
    this.appState.loading = true;

    this.addressAutoCompleteService
      .addressDetails(selectedAddress, this.displayedAddressModel, selectedAddress.main_text)
      .subscribe({
        next: (result) => {
          this.displayedAddressModel = result.model;
          this.address = result.formatted;
          this.invalidAddress = false;
          this.appState.loading = false;
        },
        error: (err) => {
          this.invalidAddress = true;
          this.appState.loading = false;
          console.warn('Failed to resolve address details', err);
        }
      });
  }

  public addToCart(plan): void {
    this.checkUser(plan);
  }

  public checkCoverage(): void {
    this.compatibilityForm.form.markAllAsTouched();
    this.addressControl.markAllAsTouched();
    const action = 'freeup_check_coverage_by_imei';
    if (!!this.address && this.addressControl.valid && !!this.displayedAddressModel) {
      this.appState.loading = true;
      this.appState.resetAndExecuteCaptchaSubject.next({action});
      this.recaptchaResolvedSubscription= this.appState.resolvedCaptcha.subscribe(response => {
        this.recaptchaResponse = response;
        if(!!this.recaptchaResponse) {
          this.recaptchaResolvedSubscription?.unsubscribe();
          this.displayValidation = false;
          this.callCheckCoverageApi(this.recaptchaResponse, true, action);
        }
      });
    } else if (!this.displayedAddressModel && !this.address) {
      this.displayValidation = true;
    }
  }

  public callCheckCoverageApi(captchaRes, invisibleCaptchaRes, action?): void {
    this.equipmentService.checkNetworkCoverageByAddress(captchaRes, this.displayedAddressModel?.postalCode,
      this.displayedAddressModel?.address1, this.displayedAddressModel?.city,
      this.displayedAddressModel?.state, this.displayedAddressModel?.address2, !!action?action:null, invisibleCaptchaRes).then(res => {
        if (!!res) {
          this.appState.loading = false;
          if (!!res.covered) {
            const simCoverage = res.coveredNetworks.find(i => i.network.toLowerCase() === RED.toLowerCase());
            const defaultNetwork = simCoverage;
            this.networkType = defaultNetwork.network || RED;

            const params = {};
            params[SUPPORT_ROUTE_URLS.PARAMS.NETWORKTYPE] = this.networkType;
            params[ACTIVATION_ROUTE_URLS.PARAMS.ZIP_CODE] = this.displayedAddressModel?.postalCode;
            this.router.navigate([`${SUPPORT_ROUTE_URLS.BASE}/${SUPPORT_ROUTE_URLS.COVERAGE}`, params]);
          }
        }
      }, (error) => {
        this.handleCompatibilityError(error);
      }).catch((error)=>{
        this.handleCompatibilityError(error);
      })
  }
  public handleCompatibilityError(error) {
    this.appState.loading = false;
    this.recaptchaResolvedSubscription?.unsubscribe();
    const errorDetails = error?.error?.errors[0];
    let errorMessage = errorDetails?.message;
    
    if(errorDetails?.code !== CAPTCHA_BOT_ERROR_CODE) {    
      this.displayValidation = false;
      if (errorDetails?.code === 102) {
        const paramName = errorDetails.params[0]?.param_name;
        const paramMessage = errorDetails.params[0]?.message;
  
        if (paramName.includes('equipment') || paramName.includes('imei')) {
          errorMessage = PARAM_ERROR_MESSAGES.IMEI;
        } else if (paramMessage === 'Invalid zip code') {
          errorMessage = PARAM_ERROR_MESSAGES.ADDRESS;
        }
      }
  
      // If it's not a compatibility error, use the original error message
      errorMessage = errorMessage || errorDetails?.message || PARAM_ERROR_MESSAGES.GENERIC;
  
      this.toastHelper.showAlert(errorMessage);
    } else if(errorDetails?.code === CAPTCHA_BOT_ERROR_CODE) {
      this.modalHelper.showRecaptchaVerificationModal().afterClosed().subscribe((result) => {
        if (!!result) {
          this.appState.loading = true;
          this.callCheckCoverageApi(result, false);
        }
      });
     }
  }

  private checkUser(plan): void {
    this.simpleAuthService.userState.pipe(takeWhile(() => this.alive)).subscribe((authState) => {
      const isLoggedIn = !!authState && !authState.isAnonymous;
      if (!isLoggedIn) {
        this.angularFireService.signInAnonymously().then((user) => {
          setTimeout(() => {
            this.checkCart(plan);
          }, 1000);
        });
      } else {
        this.checkCart(plan);
      }
    });
  }

  private checkCart(plan): void {
    // eslint-disable-next-line
    if (!!this.userCart && !!this.userCart.cartType && this.userCart.cartType != CART_TYPES.NEW_PLAN) {
      this.modalHelper.showConfirmMessageModal('Clear Cart', 'Adding new plan will remove other items in your cart. Do you want to proceed?', 'Yes', 'No', 'clean-cart-modal')
        .afterClosed().subscribe((result) => {
          if (!!result) {
            setTimeout(() => {
              this.addPlan(plan);
              if ((!this.userCart.planDevice) || (!!this.userCart.planDevice && !this.userCart.planDevice.id) ||
                (!!this.userCart.planExpectedDevice && !this.userCart.planExpectedDevice.id)) {
                this.router.navigate([`${SHOP_ROUTE_URLS.BASE}/${SHOP_ROUTE_URLS.CHECK_PHONE}`]);
              } else {
                this.router.navigate([`${SHOP_ROUTE_URLS.BASE}/${SHOP_ROUTE_URLS.CART}`]);
              }
            }, 500);
          }
        }, (error) => {
          console.error('error', error);
          return false;
        });
    } else {
      this.addPlan(plan);
      this.mobilePlansService.setActivePlanId('');
      if ((!this.userCart.planDevice && !this.userCart.planExpectedDevice) || (!!this.userCart.planDevice && !this.userCart.planDevice.id) ||
        (!!this.userCart.planExpectedDevice && !this.userCart.planExpectedDevice.id)) {
        this.router.navigate([`${SHOP_ROUTE_URLS.BASE}/${SHOP_ROUTE_URLS.CHECK_PHONE}`]);
      } else {
        this.router.navigate([`${SHOP_ROUTE_URLS.BASE}/${SHOP_ROUTE_URLS.CART}`]);
      }
    }
  }

  private addPlan(plan): void {
    sessionStorage.setItem('planID', JSON.stringify(plan.id));
    if (!!this.userHasDevice) {
      this.mobilePlansService.setBasePlan(plan);
      this.mobilePlansService.setCartType(CART_TYPES.NEW_PLAN);
      this.mobilePlansService.setAutoRenewPlan(true);
    }
    const price = plan.subscriptionCycles * plan.price;
    if (!this.tracked) {
      this.tracked = true;
      this.analyticsService.trackAddToCartGA4(PURCHASE_INTENT.NEW, [plan], price);
    }
  }

  private createSwiper(): void {
    this.swiper = new Swiper('.swiper-container', {
      hashNavigation: true,
      modules: [Navigation, Pagination, Keyboard],
      ...this.config,
    });
    this.cdr.detectChanges();
    setTimeout(() => {
      this.swiper?.on('slideChange', () => {
        this.activeSlideIndex = this.swiper?.activeIndex;
      });
    }, 200);
    this.cdr.detectChanges();
  }
  private prepareSchemaData(): void {
    const structuredData = {
      '@type': 'Organization',
      '@id': `${WEBSITE_URL}/#organization`,
      name: 'FreeUp Mobile',
      url: WEBSITE_URL,
      logo: `${WEBSITE_URL}/assets/img/Freeup-Logo.svg`,
      contactPoint: [{
        '@type': 'ContactPoint',
        telephone: CUSTOMER_CARE_NUMBER,
        contactType: 'Customer Care',
        areaServed: 'US'
      }],
      sameAs: ['https://facebook.com/freeupmobile', 'https://twitter.com/freeupmobile', 'https://instagram.com/freeupmobile',
        'https://www.youtube.com/channel/UCD01UiqOExQwdoBWrislw0A?view_as=subscriber']
    };
    this.jsonLDString = this.appState.setJsonLdData(structuredData);
  }

  @HostListener('window:resize', ['$event'])
  onResize(event): void {
    this.innerWidth = document.documentElement.clientWidth;
    this.createSwiper();
  }
}
